import { config } from 'config';
import axios from 'axios';
import { flyweight } from 'commons/util/interfaces';
import { REST } from 'commons/rest/rest.js';
import { getCookie } from '@/store/modules/sites/actions.js';

/**
 * auth.{env} endpoint
 *
 */
function IAmAPI() {
    REST.call(this, axios, config.iam_url);

    this.api.interceptors.response.use((response) => response.data.result || response.data);
}

IAmAPI.prototype = Object.create(REST.prototype);

const iamAPI = flyweight(IAmAPI);

export const getIamAPI = () => iamAPI.register();

const routes = {
    current_user: () => '/v3/sections/',
};

/* Fetches the current user information from the new IAM endpoint.
 * Is used to retrieve user-accessible sections and roles.
 * Note: The existing call to currentUser will not be replaced yet, as a refactor of the console is required.
 * In the future, after the refactor, this endpoint will fully replace the old currentUser information.
*/
export const fetchCurrentUserSections = () => {
    const scope = getCookie('loginSessionUuid');
    return getIamAPI().get(`${routes.current_user()}${scope}/users/me`);
};
